import {
  Bar,
  BarChart,
  CartesianGrid,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from 'recharts';
import useSolanaMetrics from '../hooks/useSolanaMetrics';
import ChartTooltip from './ChartTooltip';
import ChartSkeleton from './ChartSkeleton';

function LiveChart({ variant = 'tps', range = '30m' }) {
  const { data, loading, error } = useSolanaMetrics(range);

  if (loading && data.length === 0) {
    return <ChartSkeleton />;
  }

  if (error && data.length === 0) {
    return (
      <p className="chart-feedback chart-error">
        {error}
        <br />
        <small>Run backend scheduler: php artisan solana:collect-metrics</small>
      </p>
    );
  }

  if (data.length === 0) {
    return (
      <p className="chart-feedback">
        No stored metrics for {range} yet. Start the Laravel scheduler to collect samples.
      </p>
    );
  }

  return (
    <div className="live-chart-wrap">
      {error ? <p className="chart-feedback chart-error">Update warning: {error}</p> : null}
      <div className="live-chart-surface">
        <ResponsiveContainer width="100%" height={220}>
          <BarChart data={data} barGap={2} barCategoryGap="22%" margin={{ top: 12, right: 8, left: 0, bottom: 6 }}>
            <CartesianGrid strokeDasharray="3 3" stroke="rgba(120,133,160,0.22)" vertical={false} />
            <XAxis dataKey="time" tick={{ fontSize: 10 }} tickMargin={8} minTickGap={20} />
            <YAxis tick={{ fontSize: 10 }} tickMargin={6} />
            <Tooltip
              content={<ChartTooltip variant={variant} />}
              cursor={{ fill: 'rgba(122, 243, 209, 0.06)' }}
              wrapperStyle={{ outline: 'none', zIndex: 20 }}
            />
            {variant === 'tps' ? (
              <>
                <Bar dataKey="trueTPS" name="True TPS" stackId="tps" fill="#7AF3D1" radius={[0, 0, 0, 0]} />
                <Bar dataKey="voteTPS" name="Vote TPS" stackId="tps" fill="#C079E6" radius={[0, 0, 0, 0]} />
              </>
            ) : (
              <Bar dataKey="ping" name="Avg Ping (ms)" fill="#7ee0d2" radius={[2, 2, 0, 0]} />
            )}
          </BarChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
}

export default LiveChart;
